import { color, GlitterGray, OnyxGray } from 'canoe';
import styled from 'styled-components';

export const Shortcut = styled.span<any>`
  border-radius: 0.25em;
  background-color: ${({ enabled }) => color(OnyxGray, enabled ? 1 : -1)};
  color: ${({ enabled }) => (enabled ? color(GlitterGray, 2) : color(OnyxGray, 2))};

  margin-left: 4px;
  margin-right: 4px;
  padding: 4px;

  min-width: 24px;
  height: 24px;

  font-size: 14px;
  line-height: 1.2em;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ rotate }: { rotate?: string }) => rotate && `transform: rotate(${rotate}deg);`}
`;
